export enum EnumIdeStatus {
    EMDIGITACAO = 10,
    PENDENTE = 20,
    FINALIZADO = 30,
    CANCELADO = 40,
}